import React, { useEffect, useState } from 'react';
import { Select, Input, message, Result, Pagination, Modal } from 'antd';
import './CreativeSubmissionsHolder.styles.scss';
import CreatorCardComponent from './CreatorCardComponent';
import { CreatorCards } from '../../../../apis/Admin/Campaigns/Creatives/CreatorCards';
import { useGlobalState } from '../../../../store/state';
import { useParams } from 'react-router';
import { AddInfluencersToCampaign } from '../../../../apis/Admin/Campaigns/AddInfluencers';

const { Option } = Select;
export const CreativeSubmissionsHolder = () => {
  const [user] = useGlobalState('user');
  const params = useParams();
  const [pageOps, setPageOps] = useState({
    limit: 9,
    page: 1,
    total: 0,
  });
  const [newInfluencersId, updateNewInfluencersId] = useState('');
  const [showAddInfluncersModal, setShowAddInfluncersModal] = useState(false);
  const [invaildInfluencers, setInvaildInfluencers] = useState([]);
  const [existingInfluencers, setExistingInfluencers] = useState([]);
  const [addedInflunecers, setAddedInfluencers] = useState([]);

  const [creators, setCreators] = useState([]);
  const getCreatorCards = (page) =>{
    const _data = {
      campId: params.campaignId,
      page: page || 1,
      limit: 9,
    };
    CreatorCards(user.accessToken, _data).then(({ response, status })=>{
      if (status === 200) {
        setCreators(response.docs || []);
        setPageOps({
          ...pageOps,
          page: response.page,
          limit: response.limit,
          total: response.totalDocs,
        });
      } else {
        message.error('There some issue whiling retriving Creator Data');
      }
    });
  };

  useEffect(() => {
    getCreatorCards(1);
  }, []);

  const creatorPageChange = (pageNumber) => {
    setPageOps({
      ...pageOps,
      page: pageNumber,
    });
    getCreatorCards(pageNumber);
  };

  const addInfluncers = async () => {
    const result = await AddInfluencersToCampaign({ token: user.accessToken, data: { campaignId: params.campaignId, influencers: newInfluencersId } });
    setExistingInfluencers([...result?.status?.existingInfluencers]);
    setAddedInfluencers([...result?.status?.newAddedInfluncers]);
    setInvaildInfluencers([...result?.status?.invalidInfluncers]);
    updateNewInfluencersId('');
  };

  return (
    <div className="creative_submissions">
      <div className="creative_submissions_top">
        <div className="d-flex justify-content-start">
          <div className="creative_submissions_top_search pr-md-3">
            <Input className="common_input "
              size="large"
              allowClear
              placeholder="Search a Influencer"/>
          </div>
          <div className="creative_submissions_top_status">
            <Select style={{ minWidth: 100 }}
              placeholder="Filter by Status"
              size="large"
              className="common_select">
              <Option value="review">In Review</Option>
              <Option value="accepted">Accepted</Option>
              <Option value="live">Live</Option>
            </Select>
          </div>
          <button style={{ marginLeft: 10, border: '1px solid grey', borderRadius: 4 }}
            onClick={() => setShowAddInfluncersModal(true)}>
                        Add Influencers
          </button>
          <Modal
            title={<>Add Influncers</>}
            visible={showAddInfluncersModal}
            onOk={addInfluncers}
            okText="Add"
            onCancel={()=>{
              setShowAddInfluncersModal(false);
            }}
            destroyOnClose={true}
          >
            <div>Campaign Id : {params?.campaignId}</div>
            <div style={{ margin: '10px 0' }}>
              <Input className="common_input"
                type="text"
                placeholder="influncers id"
                value={newInfluencersId}
                onChange={(e)=> updateNewInfluencersId(e.target.value)}
                style={{ margin: 'auto' }} />
            </div>
            {
              !!(existingInfluencers?.length || invaildInfluencers?.length || addedInflunecers?.length) &&
                          <div style={{ padding: '10px 0' }}>
                            <p style={{ fontSize: 16, fontWeight: 'bold' }}> Results:</p>

                            { !!addedInflunecers?.length &&
                            <div style={{ color: 'green' }}>
                              <p style={{ fontWeight: 'bold' }}>Newly Added Influencers:</p>
                              <ul>
                                {
                                  addedInflunecers.map((inf) => <li>{inf.influencerId}</li>)
                                }
                              </ul>
                            </div>
                            }
                            { !!existingInfluencers?.length &&
                           <div style={{ color: 'grey' }}>
                             <p style={{ fontWeight: 'bold' }}>Existing Influencers:</p>
                             <ul>
                               {
                                 existingInfluencers.map((inf) => <li>{inf.influencerId}</li>)
                               }
                             </ul>
                           </div>
                            }
                            { !!invaildInfluencers?.length &&
                           <div style={{ color: 'red' }}>
                             <p style={{ fontWeight: 'bold' }}>Invalid Influencers Id:</p>
                             <ul>
                               {
                                 invaildInfluencers.map((inf) => <li>{inf}</li>)
                               }
                             </ul>
                           </div>
                            }

                          </div>
            }

          </Modal>
        </div>
      </div>
      <div className="creative_submissions_cards">
        <div className="row my-2">
          {
            creators.length ?
              creators.map(({ influencer, _id, numberOfCreatives, numbersOfPosts }) =>{
                return <CreatorCardComponent key={influencer._id}
                  influencer={influencer}
                  creativesId={_id}
                  creativesCount={numberOfCreatives}
                  numbersOfPosts={numbersOfPosts}
                  resetAllCards={getCreatorCards}
                />;
              }) :
              <div className="col-md-4 offset-md-4"><Result title="No Creators Present"/></div>
          }
        </div>
        {
          creators.length ?
            <Pagination
              onChange={creatorPageChange}
              current={pageOps.page}
              total={pageOps.total}
              defaultPageSize={pageOps.limit}
            />:
            null
        }
      </div>
    </div>
  );
};
